import {
  EvidenceType,
  type EmissionEvidence,
  type SessionFile,
} from '../types/emissions';

/**
 * Reconstruct a minimal EmissionEvidence from a promoted SessionFile +
 * its known evidenceId. Audit timestamps fall back to `promotedAt`,
 * else "now" — close enough for the immediate post-attach render
 * before the real evidence doc is refetched server-side.
 */
export const buildEvidenceStubFromSessionFile = (
  file: SessionFile,
  evidenceId: string,
  initiativeId: string,
): EmissionEvidence => {
  const timestamp = file.promotedAt ?? new Date().toISOString();
  return {
    _id: evidenceId,
    initiativeId,
    fileName: file.fileName,
    originalName: file.originalName,
    mimeType: file.mimeType,
    fileSize: file.fileSize,
    evidenceType: file.metadata.evidenceType ?? EvidenceType.Other,
    description: file.metadata.description,
    documentDate: file.metadata.documentDate,
    periodStart: file.metadata.periodStart,
    periodEnd: file.metadata.periodEnd,
    issuer: file.metadata.issuer,
    tags: file.metadata.tags,
    isDeleted: false,
    created: timestamp,
    updated: timestamp,
  };
};
